import { styled } from '@mui/material/styles';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { baseStyles } from '../../common/baseStyles';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledMessage = _ref => {
  let {
    message
  } = _ref;
  const theme = useInterstateTheme();
  const StyledMessageDiv = styled('div')(_ref2 => {
    let {
      theme
    } = _ref2;
    return {
      flex: '1 0 0',
      overflow: 'hidden',
      color: theme.tokens.ComponentSnackbarColorMessage,
      fontFamily: theme.tokens.ComponentSnackbarFontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '125%',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      minWidth: 0,
      cursor: 'default',
      ...baseStyles
    };
  });
  return /*#__PURE__*/_jsx(StyledMessageDiv, {
    className: 'ids-snackbar-message',
    children: message
  });
};